export const result = {
  data: [
    {
      m: 50,
      m_conv: 5.0,
      time: 1718040924,
      time_conv: '2024-06-11 01:35',
      lon: 84150000,
      lat: 40890000,
      depth: 20,
      location: '新疆巴音郭楞州尉犁县',
    },
    {
      m: 57,
      m_conv: 5.7,
      time: 1717950520,
      time_conv: '2024-06-10 00:28',
      lon: 154100000,
      lat: -5450000,
      depth: 150,
      location: '巴布亚新几内亚附近海域',
    },
    {
      m: 59,
      m_conv: 5.9,
      time: 1717672071,
      time_conv: '2024-06-06 19:07',
      lon: 147900000,
      lat: 49950000,
      depth: 640,
      location: '鄂霍次克海',
    },
    {
      m: 58,
      m_conv: 5.8,
      time: 1717363900,
      time_conv: '2024-06-03 05:31',
      lon: 137400000,
      lat: 37400000,
      depth: 10,
      location: '日本本州西岸近海',
    },
    {
      m: 59,
      m_conv: 5.9,
      time: 1717202797,
      time_conv: '2024-06-01 08:46',
      lon: 86360000,
      lat: 34140000,
      depth: 8,
      location: '西藏那曲市尼玛县',
    },
    {
      m: 52,
      m_conv: 5.2,
      time: 1717175459,
      time_conv: '2024-06-01 01:10',
      lon: 121590000,
      lat: 24010000,
      depth: 10,
      location: '台湾花莲县',
    },
    {
      m: 62,
      m_conv: 6.2,
      time: 1717170881,
      time_conv: '2024-05-31 23:54',
      lon: -176600000,
      lat: -29400000,
      depth: 10,
      location: '新西兰克马德克群岛地区',
    },
    {
      m: 54,
      m_conv: 5.4,
      time: 1716988404,
      time_conv: '2024-05-29 21:13',
      lon: 94500000,
      lat: 23550000,
      depth: 90,
      location: '缅甸',
    },
    {
      m: 59,
      m_conv: 5.9,
      time: 1716897156,
      time_conv: '2024-05-28 19:52',
      lon: 95300000,
      lat: 2800000,
      depth: 20,
      location: '印尼苏门答腊岛北部海域',
    },
    {
      m: 50,
      m_conv: 5.0,
      time: 1716779230,
      time_conv: '2024-05-27 11:07',
      lon: 100700000,
      lat: 28250000,
      depth: 8,
      location: '四川凉山州木里县',
    },
    {
      m: 66,
      m_conv: 6.6,
      time: 1716756430,
      time_conv: '2024-05-27 04:47',
      lon: -174700000,
      lat: -19550000,
      depth: 140,
      location: '汤加群岛',
    },
    {
      m: 62,
      m_conv: 6.2,
      time: 1716675797,
      time_conv: '2024-05-26 06:23',
      lon: 167950000,
      lat: -17100000,
      depth: 30,
      location: '瓦努阿图群岛',
    },
    {
      m: 56,
      m_conv: 5.6,
      time: 1716463619,
      time_conv: '2024-05-23 19:26',
      lon: 47700000,
      lat: -37200000,
      depth: 10,
      location: '西南印度洋海岭',
    },
    {
      m: 50,
      m_conv: 5.0,
      time: 1716364842,
      time_conv: '2024-05-22 16:00',
      lon: 121740000,
      lat: 23800000,
      depth: 10,
      location: '台湾花莲县海域',
    },
    {
      m: 56,
      m_conv: 5.6,
      time: 1716262562,
      time_conv: '2024-05-21 11:36',
      lon: 147350000,
      lat: -6250000,
      depth: 90,
      location: '巴布亚新几内亚',
    },
    {
      m: 52,
      m_conv: 5.2,
      time: 1716181822,
      time_conv: '2024-05-20 13:10',
      lon: 77050000,
      lat: 40280000,
      depth: 19,
      location: '新疆克孜勒苏州阿图什市',
    },
    {
      m: 59,
      m_conv: 5.9,
      time: 1716111327,
      time_conv: '2024-05-19 17:35',
      lon: -171050000,
      lat: 52200000,
      depth: 30,
      location: '福克斯群岛',
    },
    {
      m: 58,
      m_conv: 5.8,
      time: 1716041084,
      time_conv: '2024-05-18 22:04',
      lon: 152200000,
      lat: -3850000,
      depth: 10,
      location: '新爱尔兰地区',
    },
    {
      m: 56,
      m_conv: 5.6,
      time: 1715706948,
      time_conv: '2024-05-15 01:15',
      lon: 150200000,
      lat: -5650000,
      depth: 110,
      location: '巴布亚新几内亚',
    },
    {
      m: 64,
      m_conv: 6.4,
      time: 1715513954,
      time_conv: '2024-05-12 19:39',
      lon: -92300000,
      lat: 14550000,
      depth: 80,
      location: '墨西哥沿岸近海',
    },
  ],
  status: 0,
  msg: '',
}
